import {
  BiIdCard,
  BiGrid,
  BiBuilding,
  BiHorizontalLeft,
  BiHorizontalRight,
  BiCalendarPlus,
  BiDialpad,
  BiUserCircle,
  BiTransferAlt,
  BiBarChartAlt,
  BiDialpadAlt,
} from "react-icons/bi";
import { DashboardOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { AuthContext } from "contexts";

export default [
  {
    label: <Link to="/">Хянах самбар</Link>,
    icon: <DashboardOutlined size={16} className="inline text-[#F19920]" />,
    key: "dahboard",
    role: ["Админ", "Удирдлага", "Менежер"],
  },
  {
    label: <Link to="/news">Мэдээ</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "news",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/job/postion">Ажлын байр</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "jobs",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/job/applicants">Өргөдлүүд</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "apps",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/training">Сургалт</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "training",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/doctor">Эмч</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "doctor",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/service">Үйлчилгээ</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "services",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/partner">Хамтрагчид</Link>,
    icon: <BiGrid size={16} className="inline text-[#F19920]" />,
    key: "partner",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: <Link to="/aboutus">Бидний тухай</Link>,
    icon: <BiBarChartAlt size={16} className="inline text-[#F19920]" />,
    key: "aboutus",
    role: ["Админ", "Удирдлага", "Менежер", "Нягтлан"],
  },
  {
    label: "Хүний нөөц",
    type: "group",
    role: ["Админ", "Удирдлага", "Менежер"],
    hospital: [1, 2],
    icon: <BiIdCard size={16} className="inline text-[#F19920]" />,
    children: [
      {
        label: <Link to="/employee">Ажилчид</Link>,
        key: "employee",
        role: ["Админ", "Удирдлага", "Менежер"],
        hospital: [1, 2],
        icon: <BiUserCircle size={16} className="inline text-[#F19920]" />,
      },
    ],
  },
];
